export default {
    submit: 'bloko-tree-selector-popup-submit',
    cancel: 'bloko-tree-selector-popup-cancel',
    search: 'bloko-tree-selector-popup-search',
    notFound: 'bloko-tree-selector-popup-not-found',
};
